import React from 'react';
import { Pressable } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Stack } from '@/components/layout/stack';
import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

export type CompactHeaderProps = {
  title: string;
  onBack: () => void;
};

export function CompactHeader({ title, onBack }: CompactHeaderProps) {
  const styles = useStyles();
  const { scale } = useScaling();
  const insets = useSafeAreaInsets();

  return (
    <Stack
      direction="row"
      align="center"
      gap={scale(8)}
      backgroundColor={colors['0']}
      paddingTop={insets.top + scale(2)}
      paddingX={scale(20)}
      paddingBottom={scale(4)}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Back"
        onPress={onBack}
        style={({ pressed }) => [styles.backButton, pressed && styles.pressed]}>
        <SvgIcon name="IcBackBlue" size={scale(24)} color={guardianColors['10']} />
      </Pressable>
      <Text
        variant="Font Guardian App/Heading/Heading H6 18px"
        numberOfLines={1}
        style={styles.title}>
        {title}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  backButton: {
    width: scale(40),
    height: scale(40),
    borderRadius: scale(20),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: guardianColors['1'],
  },
  pressed: {
    opacity: 0.72,
  },
  title: {
    flex: 1,
    color: guardianColors['10'],
  },
}));
